import React from 'react';
import { legacy_createStore as createStore, combineReducers } from 'redux';
import { toast } from 'react-toastify';
import { publish } from './global-events';
import WebClient from 'utils/webclient';
import IKhcHub from './khc-hub';

let _ih = null;
let khcSocket = null;

const maintenance = (state = false, action) => {
  switch (action.type) {
    case 'SET_Maintenance': {
      return action.payload;
    }
    default:
      return state;
  }
};

const member = (state = null, action) => {
  switch (action.type) {
    case 'SET_MEMBER_DATA': {
      return { ...state, ...action.payload };
    }
    case 'LOGOUT': {
      return null;
    }
    case 'RESET_MEMBER_DATA': {
      return action.payload;
    }
    default:
      return state;
  }
};

const language = (state = null, action) => {
  switch (action.type) {
    case 'SET_LANGUAGE': {
      return action.payload;
    }
    default:
      return state;
  }
};

const surveyAnsver = (state = false, action) => {
  switch (action.type) {
    case 'SET_SurveyAnsver': {
      return action.payload;
    }
    default:
      return state;
  }
};

const videoCall = (state = null, action) => {
  switch (action.type) {
    case 'SET_VIDEO_CALL': {
      return action.payload;
    }
    default:
      return state;
  }
};

const videoCallSurvey = (state = null, action) => {
  switch (action.type) {
    case 'SET_VIDEO_CALL_SURVEY': {
      return action.payload;
    }
    default:
      return state;
  }
};

const languages = (state = [], action) => {
  switch (action.type) {
    case 'SET_LANGUAGES': {
      return action.payload;
    }
    default:
      return state;
  }
};

const tokenObject = (state = {}, action) => {
  switch (action.type) {
    case 'SET_TOKEN_OBJECT': {
      return action.payload;
    }
    default:
      return state;
  }
};

const access_token = (state = null, action) => {
  switch (action.type) {
    case 'SET_ACCESS_TOKEN': {
      return action.payload;
    }
    default:
      return state;
  }
};

const nationalities = (state = [], action) => {
  switch (action.type) {
    case 'SET_NATIONALITIES': {
      return action.payload;
    }
    default:
      return state;
  }
};

const hospitals = (state = [], action) => {
  switch (action.type) {
    case 'SET_HOSPITALS': {
      return action.payload;
    }
    default:
      return state;
  }
};

const languageId = (state = 1, action) => {
  switch (action.type) {
    case 'SET_LANGUAGE_ID': {
      return action.payload;
    }
    default:
      return state;
  }
};

const patient = (state = null, action) => {
  switch (action.type) {
    case 'SET_PATIENT_DATA': {
      return action.payload;
    }
    default:
      return state;
  }
};

const patientHas = (state = null, action) => {
  switch (action.type) {
    case 'SET_PATIENT_HAS_DATA': {
      return action.payload;
    }
    default:
      return state;
  }
};

const referenceCode = (state = null, action) => {
  switch (action.type) {
    case 'SET_REFERENCE_CODE': {
      return action.payload;
    }
    default:
      return state;
  }
};

const hospital = (state = null, action) => {
  switch (action.type) {
    case 'SET_HOSPITAL': {
      return action.payload;
    }
    default:
      return state;
  }
};

const genders = (state = [], action) => {
  switch (action.type) {
    case 'SET_GENDERS': {
      return action.payload;
    }
    default:
      return state;
  }
};

const common = (state = { notificationState: 'unsupported' }, action) => {
  switch (action.type) {
    case 'SET_STATE': {
      return { ...state, ...action.payload };
    }
    default:
      return state;
  }
};

const basket = (state = {}, action) => {
  switch (action.type) {
    case 'SET_BASKET':
      return action.payload;
    case 'ADD_TO_BASKET':
      return { ...state, totalQuantity: state.totalQuantity + action.payload };
    case 'REMOVE_FROM_BASKET':
      const productToRemove = state.basketItems.find(
        item =>
          item.productId === action.payload.productId &&
          item.productType === action.payload.productType
      );
      const basketItems = state.basketItems.filter(item => item !== productToRemove);
      const { quantity, totalPrice } = productToRemove;
      return {
        ...state,
        totalQuantity: state.totalQuantity - quantity,
        totalAmount: state.totalAmount - totalPrice,
        basketItems,
      };
    default:
      return state;
  }
};

const basketCount = (state = 0, action) => {
  switch (action.type) {
    case 'SET_BASKET_COUNT': {
      return action.payload;
    }
    default:
      return state;
  }
};

const loading = (state = false, action) => {
  switch (action.type) {
    case 'SET_LOADING': {
      return action.payload;
    }
    default:
      return state;
  }
};

const alert = (state = true, action) => {
  switch (action.type) {
    case 'SET_ALERT': {
      return action.payload;
    }
    default:
      return state;
  }
};

const notificationCount = (state = 0, action) => {
  switch (action.type) {
    case 'SET_NOTIFICATION_COUNT': {
      return action.payload;
    }
    default:
      return state;
  }
};

const doctorJoined = (state = null, action) => {
  switch (action.type) {
    case 'SET_DOCTOR_JOINED': {
      return action.payload;
    }
    default:
      return state;
  }
};

const registerStart = (state = null, action) => {
  switch (action.type) {
    case 'SET_REGISTER_START': {
      return action.payload;
    }
    default:
      return state;
  }
};

const verifyForeignPatient = (state = false, action) => {
  switch (action.type) {
    case 'SET_VERIFY_FOREIGN_PATIENT': {
      return action.payload;
    }
    default:
      return state;
  }
};

const withingsUserId = (state = null, action) => {
  switch (action.type) {
    case 'SET_WITHINGS_USER_ID': {
      return action.payload;
    }
    default:
      return state;
  }
};
export const SELECTED_HOSPITAL_KEY = 'selectedHospital';
const selectedHospitalInitialState =
  JSON.parse(localStorage.getItem(SELECTED_HOSPITAL_KEY)) || null;
const selectedHospital = (state = selectedHospitalInitialState, action) => {
  switch (action.type) {
    case 'SET_SELECTED_HOSPITAL': {
      return action.payload;
    }
    case 'CLEAR_SELECTED_HOSPITAL': {
      return null;
    }
    default:
      return state;
  }
};

const initialState = localStorage.getItem('paymentType') || null;
const paymentType = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_PAYMENT_TYPE': {
      return action.payload;
    }
    default:
      return state;
  }
};

const initialRedirectState = {
  routeName: '',
  params: {},
};

const redirect = (state = initialRedirectState, actions) => {
  switch (actions.type) {
    case 'SET_REDIRECT':
      return { ...state, ...actions.payload };
    case 'RESET_REDIRECT':
      return initialRedirectState;
    default:
      return state;
  }
};

const combinedReducer = combineReducers({
  maintenance,
  member,
  language,
  languages,
  surveyAnsver,
  tokenObject,
  access_token,
  nationalities,
  languageId,
  patient,
  patientHas,
  referenceCode,
  hospital,
  hospitals,
  genders,
  basket,
  basketCount,
  common,
  videoCall,
  videoCallSurvey,
  loading,
  alert,
  notificationCount,
  doctorJoined,
  registerStart,
  verifyForeignPatient,
  withingsUserId,
  redirect,
  paymentType,
  selectedHospital,
});

export const store = createStore(
  combinedReducer,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

export function setRegisterStartedDate() {
  store.dispatch({
    type: 'SET_REGISTER_START',
    payload: new Date().toISOString(),
  });
}

export function setDoctorJoined(payload) {
  store.dispatch({
    type: 'SET_DOCTOR_JOINED',
    payload,
  });
}

export function setCommonState(payload) {
  store.dispatch({
    type: 'SET_STATE',
    payload,
  });
}

export function setVideoCallState(payload) {
  store.dispatch({
    type: 'SET_VIDEO_CALL',
    payload,
  });
}

export function setVideoCallSurveyState(payload) {
  store.dispatch({
    type: 'SET_VIDEO_CALL_SURVEY',
    payload,
  });
}

export function setBasket(payload) {
  store.dispatch({
    type: 'SET_BASKET',
    payload,
  });
}

export function setBasketCount(payload) {
  store.dispatch({
    type: 'SET_BASKET_COUNT',
    payload,
  });
}

export function addToBasket(payload) {
  store.dispatch({
    type: 'ADD_TO_BASKET',
    payload,
  });
}

export function removeFromBasket(payload) {
  store.dispatch({
    type: 'REMOVE_FROM_BASKET',
    payload,
  });
}

export function setLanguages(payload) {
  store.dispatch({
    type: 'SET_LANGUAGES',
    payload,
  });
}

export function setHospitals(payload) {
  store.dispatch({
    type: 'SET_HOSPITALS',
    payload,
  });
}

export function setLanguage(payload) {
  store.dispatch({
    type: 'SET_LANGUAGE',
    payload,
  });
}

export function setSurveyAnsver(payload) {
  store.dispatch({
    type: 'SET_SurveyAnsver',
    payload,
  });
}

export function setNationalities(payload) {
  store.dispatch({
    type: 'SET_NATIONALITIES',
    payload,
  });
}

export function setMaintenance(payload) {
  store.dispatch({
    type: 'SET_Maintenance',
    payload,
  });
}

export function setMemberData(payload) {
  sessionStorage.setItem('member_data', JSON.stringify(payload));
  store.dispatch({
    type: 'SET_MEMBER_DATA',
    payload,
  });
}

export function setPatientData(payload) {
  sessionStorage.setItem('patient_data', JSON.stringify(payload));
  store.dispatch({
    type: 'SET_PATIENT_DATA',
    payload,
  });
}

export function setPatientHasData(payload) {
  sessionStorage.setItem('patient_has_data', JSON.stringify(payload));
  store.dispatch({
    type: 'SET_PATIENT_HAS_DATA',
    payload,
  });
}

export function setReferenceCode(payload) {
  sessionStorage.setItem('reference_code', JSON.stringify(payload));
  store.dispatch({
    type: 'SET_REFERENCE_CODE',
    payload,
  });
}

export function setLanguageId(payload) {
  store.dispatch({
    type: 'SET_LANGUAGE_ID',
    payload,
  });
}

export function setHospital(payload) {
  store.dispatch({
    type: 'SET_HOSPITAL',
    payload,
  });
}

export function setGenders(payload) {
  store.dispatch({
    type: 'SET_GENDERS',
    payload,
  });
}

export function setLoading(payload) {
  store.dispatch({
    type: 'SET_LOADING',
    payload,
  });
}

export function setAlert(payload) {
  store.dispatch({
    type: 'SET_ALERT',
    payload,
  });
}

export function setNotificationCount(payload) {
  store.dispatch({
    type: 'SET_NOTIFICATION_COUNT',
    payload,
  });
}

export function setVerifyForeignPatient(payload) {
  store.dispatch({
    type: 'SET_VERIFY_FOREIGN_PATIENT',
    payload,
  });
}

let logoutPromise = null;

export function isLogoutInProgress() {
  return logoutPromise != null;
}

export function waitForLogout() {
  return logoutPromise ?? Promise.resolve();
}

// ayni anda gelen logout cagrilari tek bir istekte birlestirilir
export function logout(deepLink = null) {
  if (logoutPromise) return logoutPromise;

  logoutPromise = performLogout(deepLink).finally(() => {
    logoutPromise = null;
  });

  return logoutPromise;
}

async function performLogout(deepLink) {
  try {
    await PatientLogout();
  } catch (error) {
  } finally {
    DisconnectKhcSocket();
    // sessionStorage.clear()
    publish('onClearCookie');

    localStorage.removeItem('theme');

    store.dispatch({
      type: 'RESET_MEMBER_DATA',
      payload: null,
    });

    store.dispatch({
      type: 'SET_PATIENT_DATA',
      payload: null,
    });

    store.dispatch({
      type: 'SET_ALERT',
      payload: true,
    });

    // kullanici logout oldugunda ayni hastaneden login olmaya devam etmesi icin
    // bu alan kaldirilir
    clearSelectedHospital();

    if (deepLink) {
      setTimeout(() => {
        window.location.href = deepLink;
      }, 0);
    }
  }
}

export function setTokenObject(payload) {
  localStorage.setItem('access_token', payload.token);
  localStorage.setItem('expireDate', payload.expireDate);

  store.dispatch({
    type: 'SET_ACCESS_TOKEN',
    payload: payload.token,
  });

  store.dispatch({
    type: 'SET_TOKEN_OBJECT',
    payload,
  });
}

export function initIntl(intl) {
  // _ih = new IntlHelper(intl)
}

export function InitKhcSocket(intl) {
  khcSocket = new IKhcHub(intl);
}

export function ConnectKhcSocket() {
  khcSocket.Start();
}

export function DisconnectKhcSocket() {
  khcSocket.Disconnect();
}

export function OnKhcSocket(method, callback = () => {}, error = () => {}) {
  khcSocket.On(method, callback, error);
}

export function checkIntl() {
  return _ih == null;
}

export function _fm(id, values = {}) {
  // return _ih.fm(id, values)
}

const toastOpts = {
  position: 'bottom-center',
  autoClose: 2500,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: false,
  pauseOnFocusLoss: false,
  draggable: false,
  progress: undefined,
  theme: 'colored',
};

export function toastSuccess(message) {
  toast.success(message, toastOpts);
}

export function toastError(message) {
  toast.error(message, toastOpts);
}

export function toastSuccessLocalized(message) {
  toast.success(message, toastOpts);
}

export function toastErrorLocalized(message) {
  toast.error(message, toastOpts);
}

export function handleSwitchLanguage(languageId) {
  let member = store.getState().member;
  let selectedHospital = store.getState().selectedHospital;
  if (member != null && selectedHospital != null) {
    let c = new WebClient();
    c.post('573D6FBC30D637/ChangeLanguage', { languageId }, true, false, false);
  }
}

const LOGOUT_TIMEOUT_MS = 10000;

async function PatientLogout() {
  let c = new WebClient();
  let timeoutId;
  const timeout = new Promise((_, reject) => {
    timeoutId = setTimeout(() => reject(new Error('logout_timeout')), LOGOUT_TIMEOUT_MS);
  });

  try {
    return await Promise.race([c.post('443376B83AD660/Logout', {}, true, false, false), timeout]);
  } finally {
    clearTimeout(timeoutId);
  }
}

export function setSelectedHospital(payload) {
  localStorage.setItem(SELECTED_HOSPITAL_KEY, JSON.stringify(payload));
  store.dispatch({
    type: 'SET_SELECTED_HOSPITAL',
    payload,
  });
}

export function clearSelectedHospital() {
  localStorage.removeItem(SELECTED_HOSPITAL_KEY);
  store.dispatch({
    type: 'CLEAR_SELECTED_HOSPITAL',
  });
}

export function setWithingsUserId(payload) {
  store.dispatch({
    type: 'SET_WITHINGS_USER_ID',
    payload,
  });
}

export const setRedirect = (routeName, params = {}) => {
  store.dispatch({
    type: 'SET_REDIRECT',
    payload: { routeName, params },
  });
};

export const resetRedirect = () => {
  store.dispatch({
    type: 'RESET_REDIRECT',
  });
};

export function setPaymentType(payload) {
  store.dispatch({
    type: 'SET_PAYMENT_TYPE',
    payload,
  });
}
